<template>
  <div :id="this.$route.name">
    <Card back>
      <template v-slot:header>
        <h4 class="d-inline">{{ title }}</h4>
        <hr />
      </template>
      <template v-slot:content>
        <tab :tab="Tablist">
          <template v-slot:content0>
            <form  autocomplete="off">
              <div class="container mt-3 mb-3 text-right">
                <div class="row">
                  <div class="col-lg-8 col-12">
                    <div class="row">
                      <div class="col-lg-6 col-12">
                        <div class="mt-3">
                          <small id="LblUserCode">کد کاربری </small>
                          <input @keypress="$ValidNumber($event, 3)" type="text" class="form-control InputText required" v-model="DataAxios.UserCode" />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small id="LblUserNameDashBoard">نام کاربری داشبورد</small>
                          <input @keypress="$ValidLenght($event, 30)" type="text" class="form-control InputText" v-model="DataAxios.UserNameDashBoard" />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12">
                        <div class="mt-3">
                          <small id="LblUserName">نام کاربری</small>
                          <input @keypress="$ValidLenght($event, 30)" type="text" class="form-control InputText required" v-model="DataAxios.UserName" autocomplete="off" />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small id="LblPss">کلمه عبور</small>
                          <input @keyup="$PassProgress($route.name)" type="password" id="NewPass" class="form-control text-center required-Pass required ired-Pass" v-model="DataAxios.Pss" autocomplete="new-password" />
                          <div class="progress-bar d-block mt-2" style="height: 5px">
                            <div style="width: 0%" id="progress-progress">
                              <b></b>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-12">
                        <div class="mt-3">
                          <small id="LblNamFam">نام کامل</small>
                          <input @keypress="$ValidLenght($event, 30)" type="text" class="form-control InputText required" v-model="DataAxios.NamFam" />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small id="LblUserCodeMeli">کد ملی</small>
                          <input type="text" maxlength="10" class="form-control InputText" @keypress="$ValidNumber($event, 10)" v-model="DataAxios.UserCodeMeli" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4col-12 text-right">
                    <div class="mt-3">
                      <small id="LblUserperNo">شماره پرسنلی</small>
                      <input type="text" class="form-control InputText" @keypress="$ValidNumber($event, 10)" v-model.number="DataAxios.UserperNo" />
                    </div>
                    <div class="mt-3">
                      <small id="LblArchive">غیرفعال کردن کاربر</small>
                      <span class="form-control p-1">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input InputText" id="Archive" v-model="DataAxios.Archive" />
                          <label class="custom-control-label" for="Archive">غیرفعال کردن کاربر</label>
                        </div>
                      </span>
                    </div>
                    <div class="pt-1">
                      <div class="mt-5">
                        <small id="LblUserCodeMeli">آیدی VOIP</small>
                        <input type="text" maxlength="10" class="form-control InputText" @keypress="$ValidNumber($event, 10)" v-model="DataAxios.VoipExtension" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-lg-4 col-12">
                    <small id="LblUserMobile">شماره موبایل کاربر</small>
                    <input @keypress="$ValidNumber($event, 11)" type="number" class="form-control InputText" v-model="DataAxios.UserMobile" />
                  </div>
                  <div class="col-lg-4 col-12 text-right">
                    <small id="LblMoxafafJahateChap">مخفف جهت چاپ</small>
                    <input @keypress="$ValidLenght($event, 30)" type="text" class="form-control InputText" v-model="DataAxios.MoxafafJahateChap" />
                  </div>
                  <div class="col-lg-4 col-12 text-right">
                    <div class="mt-3">
                      <small id="LblUserHasBeenLocked"></small>
                      <span class="form-control p-1 mt-4">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input InputText" id="UserLock" v-model="DataAxios.UserHasBeenLocked" />
                          <label class="custom-control-label" for="UserLock">قفل کاربر</label>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </template>
          <template v-slot:content1 v-if="$route.params.Status == 'Edit'">
            <div class="alert alert-secondary text-center my-2" style="font-size: 16px">
              انتساب سمت به کاربر <b class="mx-2 text-secondary font-weight-bold">[ {{ DataAxios.UserName }} ]</b> با کد کاربری <b class="mx-2 text-secondary font-weight-bold"> [ {{ DataAxios.UserCode }} ]</b>
            </div>
            <div class="mb-3 mt-3">
              <a
                class="d-inline float-right mx-2 mt-1"
                href="javascript:;"
                v-if="AddMode == 0"
                @click="
                  AddMode = 1
                  Reload()
                "
                title="افزودن سمت"
              >
                <h4>
                  <i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i>
                </h4>
              </a>
              <a
                class="d-inline float-right mx-2 mt-1"
                href="javascript:;"
                v-if="AddMode == 1 || AddMode == -1"
                @click="
                  AddMode = 0
                  Reload()
                "
                title="لغو افزودن"
              >
                <h4>
                  <i class="fas fa-times text-danger"></i>
                </h4>
              </a>
            </div>
            <div v-if="AddMode == 1 || AddMode == -1" class="p-2 mb-2 d-block">
              <div class="d-block">
                <select id="GrpDb" class="form-control mt-2 mb-2" v-model="GrpIdSelected">
                  <option value="-1">
                    <span>یک سمت برای کاربر انتخاب کنید</span>
                  </option>
                  <option :value="item.id" v-for="item in GrpList" :id="item.id" :key="item.id">
                    <span>{{ item.GName }}</span>
                  </option>
                </select>
              </div>
              <div class="d-block">
                <div class="row mb-3">
                  <div class="col-lg-2 col-12 text-right">
                    <span class="form-control p-1 text-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" id="Asli" v-model="DataUserGrpForSave.Asli" />
                        <label class="custom-control-label" for="Asli">اصلی</label>
                      </div>
                    </span>
                  </div>
                  <div class="col-lg-4 col-12 text-right">
                    <span class="form-control p-1 text-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" id="UserForSystem" v-model="DataUserGrpForSave.UserForSystem" />
                        <label class="custom-control-label" for="UserForSystem">استفاده برای سیستم های خودکار</label>
                      </div>
                    </span>
                  </div>
                  <div class="col-lg-3 col-12 text-right">
                    <span class="form-control p-1 text-center">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" id="IsArchive" v-model="DataUserGrpForSave.IsArchive" />
                        <label class="custom-control-label" for="IsArchive">بایگانی سمت</label>
                      </div>
                    </span>
                  </div>
                  <div class="col-lg-3 col-12 text-right">
                    <button v-if="AddMode == 1" id="SaveEditData" type="submit" class="btn btn-success mr-1 w-100" dir="ltr" @click="SetUserGrp(true)">
                      ثبت اطلاعات
                      <span class="fad fa fa-check mx-2"></span>
                    </button>
                    <button v-if="AddMode == -1" id="SaveEditData" type="submit" class="btn btn-warning mr-1 w-100" dir="ltr" @click="SetUserGrp(false)">
                      ویرایش سمت انتسابی
                      <span class="fad fa fa-check mx-2"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <Bnp-Grid v-if="AddMode == 0 && $store.state.renderComponentGrid" :action="true" :propsColumn="columns" :propsRows="RowGridUserGrp">
              <template slot="action-slot" slot-scope="props">
                <a href="javascript:;" class="mr-2 badge" @click="OnEditNew(props.props)"
                  ><h6><span class="fas fa-marker text-secondary hover-warning"></span></h6
                ></a>
              </template>
            </Bnp-Grid>
          </template>
          <template v-slot:content2 v-if="$route.params.Status == 'Edit'">
            <small id="lbl">روز های مجاز به ورود به سامانه</small>
            <div class="row">
              <div class="col-md-2 col-12">
                <div class="mt-3">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" id="Shanbe" v-model="DataAxios.Shanbe" />
                      <label class="custom-control-label" for="Shanbe">شنبه</label>
                    </div>
                  </span>
                </div>
              </div>

              <div class="col-md-2 col-12">
                <div class="mt-3">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" id="YekShanbe" v-model="DataAxios.YekShanbe" />
                      <label class="custom-control-label" for="YekShanbe">یک‌شنبه</label>
                    </div>
                  </span>
                </div>
              </div>
              <div class="col-md-2 col-12">
                <div class="mt-3">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" id="DoShanbe" v-model="DataAxios.DoShanbe" />
                      <label class="custom-control-label" for="DoShanbe">دوشنبه</label>
                    </div>
                  </span>
                </div>
              </div>
              <div class="col-md-2 col-12">
                <div class="mt-3">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" id="SeShanbe" v-model="DataAxios.SeShanbe" />
                      <label class="custom-control-label" for="SeShanbe">سه‌شنبه</label>
                    </div>
                  </span>
                </div>
              </div>
              <div class="col-md-2 col-12">
                <div class="mt-3">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" id="ChaharShanbe" v-model="DataAxios.ChaharShanbe" />
                      <label class="custom-control-label" for="ChaharShanbe">چهارشنبه</label>
                    </div>
                  </span>
                </div>
              </div>
              <div class="col-md-2 col-12">
                <div class="mt-3">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" id="PanjShanbe" v-model="DataAxios.PanjShanbe" />
                      <label class="custom-control-label" for="PanjShanbe">پنج‌شنبه</label>
                    </div>
                  </span>
                </div>
              </div>
              <div class="col-md-2 col-12">
                <div class="mt-3">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input InputText" id="Jome" v-model="DataAxios.Jome" />
                      <label class="custom-control-label" for="Jome">جمعه</label>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12 border Rounded p-2 m-1">
                <div class="row col-12">
                  <div class="col-12">
                    <h5>تنظیم IP ورود کاربران</h5>
                    <p class="font-small text-secondary">در صورتی که این فیلد خالی باشد هیچ محدودیتی برای کاربر در نظر گرفته نمیشود</p>
                    <p class="font-small text-secondary">برای وارد کرد بیش از یک آی پی بین آدرس ها "/" قرار دهید</p>
                  </div>
                  <div class="col-12">
                    <input type="text" placeholder="IP Addresses ... " dir="ltr" v-model="DataAxios.Ip" class="text-left form-control" />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:content3 v-if="renderIDCardInfoTab & $route.params.Status == 'Edit'">
              <div class="container mt-3 mb-3 text-right" id="idCardInfo">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>نام</small>
                          <input type="text" class="form-control InputText required" v-model="DataAxios.TblIDCardInfo.FirstName" />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>نام خانوادگی</small>
                          <input type="text" class="form-control InputText required" v-model="DataAxios.TblIDCardInfo.LastName" />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>نام پدر</small>
                          <input type="text" class="form-control InputText required" v-model="DataAxios.TblIDCardInfo.FatherName" />
                        </div>
                      </div> 
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>کد ملی</small>
                          <input type="text" @keypress="$ValidNumber($event, 10)" class="form-control InputText required" v-model="DataAxios.TblIDCardInfo.IDCardNumber" />
                        </div>
                      </div>
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>سری شناسنامه</small>
                          <input type="text" class="form-control InputText required" v-model="DataAxios.TblIDCardInfo.IDCardSeries" />
                        </div>
                      </div> 
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>سریال شناسنامه</small>
                          <input type="text" class="form-control InputText required" v-model="DataAxios.TblIDCardInfo.IDCardSerial" />
                        </div>
                      </div> 

                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>تاریخ تولد</small>
                          <date-picker input-class="required form-control" color="dimgray" type="datetime"
                            v-model="DataAxios.TblIDCardInfo.BirthDate" clearable :editable="true" placeholder="تاریخ پایان"></date-picker>
                        </div>
                      </div> 
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>کد بیمه</small>
                          <input type="number" class="form-control InputText required" v-model="DataAxios.TblIDCardInfo.InsuranceCode" />
                        </div>
                      </div> 
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>موبایل</small>
                          <input type="number" class="form-control InputText required"  @keypress="$ValidNumber($event, 11)" v-model="DataAxios.TblIDCardInfo.MobileNumber" />
                        </div>
                      </div> 
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>شماره حساب حقوق</small>
                          <input type="number" class="form-control InputText required" v-model="DataAxios.TblIDCardInfo.SalaryAccountNumber" />
                        </div>
                      </div> 
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>نام بانک</small>
                          <input type="text" class="form-control InputText required" v-model="DataAxios.TblIDCardInfo.BankName" />
                        </div>
                      </div> 
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>تلفن</small>
                          <input type="number" class="form-control InputText" @keypress="$ValidNumber($event, 11)" v-model="DataAxios.TblIDCardInfo.PhoneNumber" />
                        </div>
                      </div> 
                      <div class="col-lg-6 col-12 text-right">
                        <div class="mt-3">
                          <small>آدرس</small>
                          <textarea type="number" class="form-control InputText" v-model="DataAxios.TblIDCardInfo.Address" ></textarea>
                        </div>
                      </div> 

                      <div class="col-lg-6 col-12 text-right mt-3 mt-lg-5">
                        <button class="btn btn-success" @click="submitIDCardInfo()">ثبت اطلاعات شناسنامه ای</button>
                      </div> 

                    </div>
                  </div>
                </div>


              </div>

          </template>
          <template v-slot:content4 v-if="$route.params.Status == 'Edit'" >
            <div class="row px-3" :key="Render">
              <div class="col-12"> <span class="">سمت کاربر برای اتوماسیون ادراری را انتخاب کنید </span> </div>
              <div class="col-md-3 col-12 my-2 text-center" v-for="(item,key) in ListGrp105UserRole" :key="key">
                <div :class="DataAxios.tblComboGrpId105UserRole!=null && DataAxios.tblComboGrpId105UserRole==item.id?'BoxSelected Pointer':'Box Pointer'" @click="SetUserRole(item)">{{ item.name }}</div>
              </div>
            </div>
          </template>
        </tab>
        <btn-edit-data v-if="$route.params.Status == 'Edit'" :DataParanet="DataAxios"></btn-edit-data>
        <btn-save-data v-if="$route.params.Status == 'Add'" @Success="AddSuccess" :DataParanet="DataAxios"></btn-save-data>
      </template>
    </Card>
  </div>
</template>
<script>
import BnpGrid from '../../components/BnpGrid/BnpGrid'

import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue'
import Card from '../../components/Card/Card.vue'
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue'
import Tab from '@/components/Tab/Tab.vue'
import VuePersianDatetimePicker from "vue-persian-datetime-picker"

export default {
  data() {
    return {
      Tablist: [{ header: 'اطلاعات کاربر' }, { header: 'سمت های کاربر' }, { header: 'تنظیمات امنیتی' }, { header: 'اطلاعات شناسنامه ای' }, { header: ' نقش کاربر در اتوماسیون اداری ' }],
      title: '',
      DataAxios: {},
      AddMode: 0,
      DataAxoisGrp: { ArryfildValue: { SoftwareId: null, UserId: null, FormName: 'frmUserGrp', ShowView: 0 }, Method: 'post', Action: 'ReadGridColumns' },
      columns: [],
      DataAxios_GridRowUserGrp: { ArryfildValue: { Id: null }, Method: 'Get', Action: 'TarifKarbaran/GetUserGrp', Token: this.$session.get('Token') },
      RowGridUserGrp: [],
      DaraAxios_GetSematha: { ArryfildValue: {}, Method: 'Get', Action: 'TarifSematha', Token: this.$session.get('Token') },
      GrpList: [],
      GrpIdSelected: '-1',
      DataAxios_PostUserData: { ArryfildValue: {}, Method: 'Post', Action: 'TarifKarbaran/b_AddRowUserGrp', Token: this.$session.get('Token') },
      DataUserGrpForSave: {
        Id: -1,
        TblUserId: 1,
        TblGrpId: 1,
        Asli: false,
        ZamanInsert: '',
        TblUserGrpIdInsert: 1,
        ZamanLastEdit: '',
        TblUserGrpIdLastEdit: 1,
        InfoDes: '',
        UserForSystem: false,
        WwwHasBeenChanged: false,
        WwwtblUserGrpId: 0,
        SmstblUserGrpId: 0,
        SmsHasBeenChanged: false,
        UserForsystemCashLess: false,
        IsArchive: false,
      },
      CopyDataUserGrpForSave: {
        Id: -1,
        TblUserId: 1,
        TblGrpId: 1,
        Asli: false,
        ZamanInsert: '',
        TblUserGrpIdInsert: 1,
        ZamanLastEdit: '',
        TblUserGrpIdLastEdit: 1,
        InfoDes: '',
        UserForSystem: false,
        WwwHasBeenChanged: false,
        WwwtblUserGrpId: 0,
        SmstblUserGrpId: 0,
        SmsHasBeenChanged: false,
        UserForsystemCashLess: false,
        IsArchive: false,
      },
      renderIDCardInfoTab:false,
      DataAxios_PutUserGrp: { ArryfildValue: null, Method: 'Put', Action: this.$route.name.substring(6) + '/b_UpdateUserGrp', Token: this.$session.get('Token') },
      ListGrp105UserRole:[],
      Render: 0
    }
  },
  components: { Card, BtnSaveData, BtnEditData, Tab, BnpGrid, datePicker: VuePersianDatetimePicker },
  created() {
    if (this.$route.params.Status) {
      if (this.$route.params.Status == 'Add') {
        if (this.$session.get(this.$route.name.substring(6))[0].isMojaz == 1) {
          this.title = 'افـزودن کـاربـر'
          // this.DataAxios = this.$store.state.TarifKarbaran.Model[0];
        } else {
          this.$swal({
            title: 'عدم دسترسی',
            text: 'عدم دسترسی به این صفحه',
            icon: 'error',
            position: 'center',
            timer: false,
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonColor: '#fa9500',
            confirmButtonText: 'بازگشت',
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.go(-1)
            }
          })
        }
      } else {
        this.title = 'ویـرایـش کـاربـر'
        this.GetRoles();
      }
    } else {
      this.$router.push({ name: this.$route.name.substring(6) })
    }
  },
  mounted() {
    if (this.$route.params.Status == 'Add') {
    } else {
      this.DataAxios = this.$route.params.DataRow
      this.$store.state.OldDataForLog = JSON.stringify(this.$route.params.DataRow)
      this.GetColumn()
      this.GetRow()
      this.GetGrp()
    }
    this.renderIDCardInfoTab = true
  },
  methods: {
    submitIDCardInfo(){
      this.DataAxios.TblIDCardInfo.tblUserId = this.DataAxios.Id
      if(this.$ValidForm('idCardInfo')){
        this.$PostData_new('post', 'TarifKarbaran/SubmitIDCardInfo', this.DataAxios.TblIDCardInfo).then((res)=>{
          if(res.isSuccess){
            this.$mySweetDefaultTost('عملیات موفق', 'اطلاعات با موفقیت ثبت شد', 'success', 2000)
          }
        }).catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سمت سرور', 'error', 2000)
          console.error(err)
        })
      }
    },
    AddSuccess(result) {
      if (result == true) {
        this.DataAxios = []
      }
    },
    GetColumn() {
      this.DataAxoisGrp.ArryfildValue.SoftwareId = this.$session.get('UserInfo').tblSoftwareId
      this.DataAxoisGrp.ArryfildValue.UserId = this.$session.get('UserInfo').tblUserId
      this.$GetColumns(this.DataAxoisGrp, true)
        .then((data) => {
          // console.log('AAA', data)
          // this.columns.push({ label: "عملیات ها", name: "id", slot_name: "action-slot", sort: false, });
          this.columns = data
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            // Add the component back in
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GetRow() {
      this.DataAxios_GridRowUserGrp.ArryfildValue.Id = this.DataAxios.Id
      this.$GetData_Header(this.DataAxios_GridRowUserGrp)
        .then((data) => {
          this.RowGridUserGrp = data
        })
        .finally(() => {
          // this.$router.push({
          //   name: "DetailTarifKarbaran",
          //   params: { Status: "Edit" ,Data:this.DataAxios},
          // });
          this.$store.state.renderComponentGrid = false
          //console.log(this.$store.state.TarifKarbaran.UserGrp);
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GetGrp() {
      this.$GetData_Body(this.DaraAxios_GetSematha)
        .then((data) => {
          this.GrpList = data
        })
        .finally(() => {})
    },
    SetUserGrp(IsAddMode) {
      if (this.GrpIdSelected != '-1' && this.GrpIdSelected != -1) {
        if (IsAddMode == true) {
          this.DataUserGrpForSave.InfoDes = 'افزودن سمت جدید'
          this.DataUserGrpForSave.ZamanLastEdit = ''
          // this.DataUserGrpForSave.ZamanInsert = this.$GetJalaliDate();
          this.DataUserGrpForSave.ZamanInsert = '1401/05/02'
          this.DataUserGrpForSave.TblUserId = this.DataAxios.Id
          this.DataUserGrpForSave.TblGrpId = this.GrpIdSelected
          this.DataUserGrpForSave.TblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
          this.DataAxios_PostUserData.ArryfildValue = this.DataUserGrpForSave
          this.$PostData(this.DataAxios_PostUserData)
            .then((data) => {
              if (data.status == 'Ok') {
                this.$swal({
                  toast: true,
                  position: 'center',
                  showConfirmButton: false,
                  title: 'ثبت موفق',
                  text: 'سمت انتخاب شده با موفقیت به کاربر اختصاص داده شد',
                  icon: 'success',
                  timer: 2000,
                  timerProgressBar: true,
                }).then(() => {
                  this.$store.state.renderComponentGrid = false
                  this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true
                  })
                })
              } else {
                if (data.eNum == 2601) {
                  this.$mySweetDefault('عدم امکان ثبت سمت انتخاب شده', 'سمت انتخاب شده ، قبلا ثبت و به کاربر مورد نظر انتساب داده شده', 'warning', 3000)
                }
                if (data.eNum == 547) {
                  this.$mySweetDefault(' عدم امکان ثبت سمت انتخابی  ', 'سمت وارد شده صحیح نمی باشد ، لطفا یکی از سمت ها را برای ویرایش انتخاب کنید', 'error', 3000)
                }
              }
            })
            .finally(() => {
              this.GetRow()
              this.$store.state.renderComponentGrid = false
              this.$nextTick(() => {
                this.AddMode = 0
                this.$store.state.renderComponentGrid = true
              })
            })
        } else {
          this.DataUserGrpForSave.ZamanInsert = ''
          this.DataUserGrpForSave.ZamanLastEdit = '1401/05/01'
          this.DataUserGrpForSave.InfoDes = 'ویرایش سمت'
          this.DataUserGrpForSave.TblUserId = this.DataAxios.Id
          this.DataUserGrpForSave.TblGrpId = this.GrpIdSelected
          this.DataUserGrpForSave.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
          this.DataUserGrpForSave.TblUserGrpIdInsert = 0

          this.DataAxios_PutUserGrp.ArryfildValue = this.DataUserGrpForSave
          this.$PostData(this.DataAxios_PutUserGrp)
            .then((data) => {
              if (data.status == 'Ok') {
                this.$swal({
                  toast: true,
                  position: 'center',
                  showConfirmButton: false,
                  title: 'ثبت موفق',
                  text: 'سمت انتخاب شده با موفقیت به کاربر اختصاص داده شد',
                  icon: 'success',
                  timer: 2000,
                  timerProgressBar: true,
                }).then(() => {
                  this.$store.state.renderComponentGrid = false
                  this.$nextTick(() => {
                    this.$store.state.renderComponentGrid = true
                  })
                })
              } else {
                if (data.eNum == 2601) {
                  this.$mySweetDefault('عدم امکان ثبت سمت انتخاب شده', 'سمت انتخاب شده ، قبلا ثبت و به کاربر مورد نظر انتساب داده شده', 'warning', 3000)
                }
                if (data.eNum == 547) {
                  this.$mySweetDefault(' عدم امکان ثبت سمت انتخابی  ', 'سمت وارد شده صحیح نمی باشد ، لطفا یکی از سمت ها را برای ویرایش انتخاب کنید', 'error', 3000)
                }
              }
            })
            .finally(() => {
              this.GetRow()
              this.Reload()
              this.$store.state.renderComponentGrid = false
              this.$nextTick(() => {
                this.AddMode = 0
                this.$store.state.renderComponentGrid = true
              })
            })
        }
      } else {
        this.$mySweetDefault('عدم انتخاب سمت', 'لطفا سمت مورد نظر را انتخاب و دوباره تلاش کنید', 'warning', 2000)
      }
    },
    OnEditNew(row) {
      console.error(row)
      this.AddMode = -1
      this.GrpIdSelected = row.TblGrpId
      this.DataUserGrpForSave = row
    },
    Reload() {
      this.DataUserGrpForSave = JSON.parse(JSON.stringify(this.CopyDataUserGrpForSave))
      this.GrpIdSelected = '-1'
    },
    GetRoles(){
      let DataAxios_SetData = {
          ArryfildValue: { Id: 105, Usergrp: null },
          Method: 'post',
          Action: 'TblCrmCombo/GetComboById',
        }
        this.$PostData(DataAxios_SetData)
          .then((data) => {
              this.ListGrp105UserRole=data
          })
    },
    SetUserRole(row){
      var formData = new FormData()
      formData.append('tblUserId', this.DataAxios.Id)
      formData.append('tblcomboGrp105UserRole', row.id)
      var DataAxios = { Method: 'POST', Action: 'TarifKarbaran/SetUserRole', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res)=>{
       if (res) {
        this.DataAxios=res
        this.$toasted.success(" تغیرات در نقش کاربر با موفقیت ثبت شد ",{duration: 3000})
        this.GetRoles();
        this.Render++
       }
      })
    }
  },
}
</script>
<style scoped>
.font-small {
  font-size: smaller !important;
}
.progress-bar {
  overflow: hidden;
  height: 20px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}

.progress-bar > div {
  /* background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent); */
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 25%, transparent 75%);
  background-size: 50px 50px;
  float: left;
  width: 0%;
  height: 100%;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
  text-align: center;
  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: width 3s ease;
  -moz-transition: width 3s ease;
  -o-transition: width 3s ease;
  transition: width 3s ease;
  animation: progress-bar-stripes 2s linear infinite;
  /* background-color: #000000; */
}

.Box{
  border: 2px dashed var(--sidebar-color-item);
  padding: 2% !important;
  border-radius: 5px;
}
.BoxSelected{
  /* border: 2px dashed #caa501; */
  background: #18b0c4;
  padding: 2% !important;
  border-radius: 5px;
}


</style>
